const examplePetriNetId = '87b6487b-5781-477e-8398-e2d8c36000be';
export default {
  petriNets: [examplePetriNetId],
  petriNetsById: {
    [examplePetriNetId]: {
      id: examplePetriNetId,
      name: 'Petri Net',
      edgesById: {},
      nodesById: {},
      markings: [{}],
    },
  },
};
